import React from 'react';
import { Select as MuiSelect, MenuItem, SelectChangeEvent } from '@mui/material';
import './Select.scss';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  id?: string;
  name?: string;
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  label?: string;
  error?: string;
  onBlur?: () => void;
}

export const Select: React.FC<SelectProps> = ({
  id = 'select',
  name = 'select',
  options,
  value,
  onChange,
  placeholder,
  className = '',
  label,
  error,
  onBlur,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <div className="select-wrapper">
      {label && <label className="select-label">{label}</label>}
      <MuiSelect
        id={id}
        name={name}
        className={`select ${className} ${error ? 'error' : ''}`}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        size="small"
        displayEmpty
      >
        {placeholder && (
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && <div className="select-error">{error}</div>}
    </div>
  );
};
